<template>
    <div class="container">
        <div class="row align-items-center">
            <div :class="'col-lg-6 col-12 text-center' +  (this.$i18n.locale === 'ar' ? 'text-lg-start' :  'text-lg-end')">
                <h2 class="title">   {{ $t('home.download_application.title') }}</h2>
                <p class="description">
                    {{ $t('home.download_application.description') }}
                </p>
                <div class="d-flex flex-row justify-content-center justify-content-lg-start gap-2">
                    <img class="stores_img" src="@/assets/images/home/application/appstore.webp" @click="directToAppStore">
                    <img class="stores_img" src="@/assets/images/home/application/playstore.webp">
                </div>
            </div>
            <div class="col-lg-6 col-12 text-center" >
                <img class="apps_img img-fluid" src="@/assets/images/home/application/application.webp">
            </div>
        </div>

    </div>
</template>
<script>
export default {
    methods : {
        directToAppStore(){
            let link = 'https://apps.apple.com/us/app/%D9%85%D9%86%D8%B5%D8%A9-%D8%A7%D9%84%D9%81%D8%B1%D9%82%D8%A7%D9%86/id1659488333';
            window.location.href = link;
        }
    }
}
</script>
<style scoped>
.container {
    margin-top: 40px;
}
.title {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 20px;
}

.description {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 20px;
}
.stores_img {
    width: 190px;
    object-fit: cover;
    cursor: pointer;
}

.apps_img {
    width: 502px;
    height: 620px;
    object-fit: cover;
}
</style>